import styled from 'styled-components'
import { zIndex } from '../../styles/vars/zIndex.style'
import { mq } from '../../styles/vars/media-queries.style'
import { easings } from '../../styles/vars/easings.style'

export const MenuToggleWrapper = styled.div`
  align-items: center;
  display: inline-flex;
  height: 100%;
  padding-left: 0.8rem;
  padding-right: 0.8rem;
  pointer-events: all;
  position: relative;
  z-index: ${zIndex.mobileNavButtons};

  &:after {
    background-color: currentColor;
    bottom: 0;
    content: '';
    left: 0;
    opacity: 0.2;
    position: absolute;
    top: 0;
    transform: scaleY(0);
    transform-origin: 0% 0%;
    width: 0.1rem;

    ${props =>
      props.ready
        ? `
      opacity: 0.2;
      transform: scaleY(1);
      transition: transform .4s ${easings.inOut.quart}, opacity .4s ${
            easings.inOut.quart
          };
      transition-delay: ${props.extraDelay ? `3s` : `.3s`};
    `
        : ``}

    ${props =>
      props.scrolled
        ? `
      transform: scaleY(0);
      transition-delay: 0s;
    `
        : ``}
  }

  ${mq.tabletL} {
    display: none;
  }
`

export const MenuToggleMain = styled.button`
  position: relative;
  width: 4.4rem;
  height: 4.4rem;
  background-color: transparent;
  border: none;
  transform: translateY(-8rem);

  ${props =>
    props.ready
      ? `
      transform: translateY(0);
      transition: transform 0.4s ${easings.out.quart},
      opacity 0.4s ${easings.out.quart};
      transition-delay: ${props.extraDelay ? `3.1s` : `.3s`};
  `
      : ``}

  ${props =>
    props.scrolled
      ? `
    transform: translateY(-8rem);
    transition-delay: 0s;
  `
      : ``}
`

export const MenuToggleBar = styled.div`
  position: absolute;
  top: calc(50% - 0.05rem);
  left: calc(50% - 1.5rem);
  width: 3rem;
  height: 0.1rem;
  background-color: currentColor;

  :nth-child(1) {
    transform: translateY(-0.6rem);
  }

  :nth-child(2) {
    left: calc(50% - 0.9rem);
    width: 2.4rem;
    ${props =>
      props.show && props.show === true
        ? `opacity: 1; transition: opacity 0s .2s;`
        : `opacity: 0;`}
  }

  :nth-child(3) {
    transform: translateY(0.6rem);
  }
`
